import { type StateCreator } from 'zustand';

export const MAIN_SIDE_NAV_OVERLAY_IDS = ['account', 'credits', 'help', 'imports', 'notifications', 'uploads'] as const;

export type MainSideNavOverlayId = (typeof MAIN_SIDE_NAV_OVERLAY_IDS)[number];
export type MainSideNavOverlaySlice = {
  activeOverlay: MainSideNavOverlayId | null;
  // One-shot signal: a shared overlay tray (MainSideNavOverlayTray) sets this before
  // closing via Escape so useMainSideNavOverlayExpand can skip its blur-on-dismiss
  // side effect and keep focus on the rail trigger. Consumers reset it immediately
  // after reading it.
  overlayClosedViaEscape: boolean;
  setActiveOverlay: (overlay: MainSideNavOverlayId | null) => void;
  setOverlayClosedViaEscape: (closedViaEscape: boolean) => void;
};

export type CreateMainSideNavOverlaySlice = (
  initialState: Pick<Partial<MainSideNavOverlaySlice>, 'activeOverlay'>,
) => StateCreator<MainSideNavOverlaySlice, [], [], MainSideNavOverlaySlice>;

export const createMainSideNavOverlaySlice: CreateMainSideNavOverlaySlice = (initialState) => (set) => ({
  activeOverlay: initialState.activeOverlay ?? null,
  overlayClosedViaEscape: false,
  setActiveOverlay: (overlay) => set({ activeOverlay: overlay }),
  setOverlayClosedViaEscape: (closedViaEscape) => set({ overlayClosedViaEscape: closedViaEscape }),
});
